$(document).ready(function() {
   console.log("A11y3 start");

     $('h2.standard__heading').attr({
      'role': 'heading',
      'aria-level': 1
    });

    $('.hero__content--transparent .hero__description p').attr({
      'role': 'heading',
      'aria-level': 2
    });

    $('[data-grid-flex] div.accent-title-large').attr({
      'role': 'heading',
      'aria-level': 3
    });

    $('.palette--light div.accent-title-large').attr({
      'role': 'heading',
      'aria-level': 3
    });
     $('.accordion__wrapper button.accordion__title').removeAttr('aria-haspopup');
     $(".accordion__wrapper button.accordion__title").attr("aria-expanded", "false");

     $(".accordion__wrapper button.accordion__title").click(function () {
       const isExpanded = $(this).attr("aria-expanded") === "true";
       console.log('isExpanded', isExpanded);
       $(this).attr("aria-expanded", String(!isExpanded));
      });
      
      
      setTimeout(function() {
  $(".collection__products .product-grid-item").each(function(index) {
    var $item = $(this);
    var $link = $item.find("product-grid-item-variant a");
    // console.log( 'sdfsdgdfgdf' + $item);

    var productTitle = $link.attr("aria-label") || "";
    var priceText = $item.find(".product__grid__info .product__grid__price").text().trim();
    var badgeAlt = $item.find(".badge-icon img").attr("alt") || "";
    var badgeSale = $item.find(".product__badge.product__badge--sale").text().trim();
    var textMsz = $item.find(".htusb-ui-coll-text_msg").text().trim();
    var boostText = $item.find(".htusb-ui-coll-boost").text().trim();

    var ariaLabelParts = [];
    if (badgeAlt) ariaLabelParts.push(badgeAlt);
    if (productTitle) ariaLabelParts.push(productTitle);
    if (priceText) ariaLabelParts.push(priceText);
    if (boostText) ariaLabelParts.push(boostText);
    setTimeout(() => {
    if (textMsz) ariaLabelParts.push(textMsz);
    }, 1000);
    if (badgeSale) ariaLabelParts.push(badgeSale);

    $link.attr("aria-label", ariaLabelParts.join(" – "));
    console.log(textMsz);
  });
}, 2000); // wait 1s







      const interactiveSelector = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="submit"]:not([disabled]), input[type="email"]:not([disabled]), select:not([disabled])';
const interactive = document.querySelectorAll(interactiveSelector);


$('body').keydown(function (event) {
	const triggered = $(event.target)[0];
	if ($('.rebuy-cart').hasClass('is-visible')) {
		const trappableContainer = $('#rebuy-cart');
		const allInteractive = trappableContainer
			.find(interactive)
			.filter(':visible');
		const first = allInteractive[0];
		const last = allInteractive[allInteractive.length - 1];
		if (event.key === 'Tab') {
			if (event.shiftKey) {
				if (triggered === first) {
					event.preventDefault();
					last.focus();
				}
			} else {
				if (triggered === last) {
					event.preventDefault();
					first.focus();
				}
			}
		}
		console.log(triggered === last, triggered, last);
	}
});

// document.addEventListener("DOMContentLoaded", function () {
   
//   // the main carousel container
//   var carousel = document.querySelector('[data-grid]');
//   // buttons
//   var prevBtn = document.querySelector('.carousel-prev');
//   var nextBtn = document.querySelector('.carousel-next');

//   if (!carousel) return;

//   prevBtn.addEventListener("click", function () {
//     carousel.scrollBy({
//       left: -carousel.clientWidth * 0.9, // scroll almost 1 screen left
//       behavior: "smooth"
//     });
//   });

//   nextBtn.addEventListener("click", function () {
//     carousel.scrollBy({
//       left: carousel.clientWidth * 0.9, // scroll almost 1 screen right
//       behavior: "smooth"
//     });
//   });

  
// });

// function updateThumbAriaCurrent() {
//   $(".media__thumb__wrapper .media__thumb").each(function() {
//     if ($(this).hasClass("is-activated")) {
//       $(this).attr("aria-current", "true");
//     } else {
//       $(this).removeAttr("aria-current");
//     }
//   });
// }

// // Run on page load
// updateThumbAriaCurrent();

// Run whenever a thumbnail is clicked
$(document).on("click", ".media__thumb__wrapper .media__thumb", function() {
  // remove active class + aria-current from all
  $(".media__thumb__wrapper .media__thumb").removeClass("is-activated").removeAttr("aria-current");

  // add to clicked one
  $(this).addClass("is-activated").attr("aria-current", "true");
});

$(".footer__socials .inline-block.align-middle.my-\\[5px\\]")
    .insertAfter(".footer__socials");
$(".subfooter__item--copyright .subfooter__copyright[data-powered-link]")
    .insertAfter("div.subfooter__item.subfooter__item--copyright");
$("h3#product-feature-heading").attr({"role":"heading", "aria-level":"2"}); 
$(".bg--neutral .grid--stacked.grid--uniform img").attr("alt", "");   


// Grab the sidebar if it already exists
const sidebar = document.querySelector('.smt-inci-sidebar');
let lastTrigger = null; // store the button that opened the sidebar

if (sidebar) {
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (sidebar.classList.contains('smt-is-visible')) {
                    console.log('Sidebar is now visible ✅');

                    // Find the button that triggered this
                    lastTrigger = document.activeElement;

                    // Make close button accessible
                    const $close = $(".smt-inci-close");
                    $close.attr({
                        "tabindex": "0",
                        "aria-label": "Close",
                        "role": "button"
                    });

                    // Keyboard trigger for close
                    $close.off('keydown.accessibility').on('keydown.accessibility', function (e) {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            $(this).trigger("click");
                        }
                    });

                    // Move focus into sidebar (first focusable element)
                    trapFocus(sidebar);

                } else {
                    console.log('Sidebar is hidden ❌');

                    // Restore focus to the last trigger
                    if (lastTrigger) {
                        lastTrigger.focus();
                        lastTrigger = null;
                    }
                }
            }
        });
    });

    // Only observe sidebar for class changes
    observer.observe(sidebar, {
        attributes: true,
        attributeFilter: ['class']
    });
}

// ---- Focus trap function ----
function trapFocus(modal) {
    const focusableSelectors = `
      a[href], button, textarea, input[type="text"], input[type="radio"],
      input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])
    `;
    const focusable = modal.querySelectorAll(focusableSelectors);
    const firstEl = focusable[0];
    const lastEl = focusable[focusable.length - 1];

    // Move focus inside
    if (firstEl) firstEl.focus();

    modal.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift+Tab
                if (document.activeElement === firstEl) {
                    e.preventDefault();
                    lastEl.focus();
                }
            } else { // Tab
                if (document.activeElement === lastEl) {
                    e.preventDefault();
                    firstEl.focus();
                }
            }
        }
    });
}
$("#shopify-section-template--19852638748901__section_double_VFwHHT h2, #shopify-section-template--19852638748901__section_double_6BnYJ4 h2").removeAttr("role").removeAttr("aria-level");
$("#shopify-section-template--19852639273189__section_product_bKGrmk h1").attr({"role":"heading", "aria-level":"2"});



    var $carousel = $('flickity-carousel > div[data-carousel]');
    var flkty = $carousel[0].flickity; // get the Flickity instance

    // Previous button
    $('#prevBtn').on('click', function() {
        flkty.previous();
        console.log("previous");
    });

    // Next button
    $('#nextBtn').on('click', function() {
        flkty.next();
        console.log("Next");
    });



    console.log("A11y3 endd");
});